import { FC, ReactNode } from 'react';
import { useIsMobile } from '@src/application/hooks/useIsMobile';

type PropsWithMandatoryChildren = { children: ReactNode };

export const Desktop: FC<PropsWithMandatoryChildren> = ({ children }) => (!useIsMobile() ? <>{children}</> : null);

export const Mobile: FC<PropsWithMandatoryChildren> = ({ children }) => (useIsMobile() ? <>{children}</> : null);
